module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e8e8e8",
      "padding": "5px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/pos/back.png")
    },
    on: {
      "click": _vm.goBack
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-810b886c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/topbar.vue
// module id = 217
// module chunks = 1